// Most of the bugsnag integration codes are from this repo
// https://github.com/bugsnag/bugsnag-js/tree/next/examples/js/nextjs

import Bugsnag from '@bugsnag/js';
import store from './store';

// eslint-disable-next-line import/prefer-default-export
export function bootstrapBugsnag() {
  // next.js executes top-level code at build time. See https://github.com/vercel/next.js/discussions/16840 for further example
  // So use NEXT_PHASE to avoid Bugsnag.start being executed during the build phase
  // See https://nextjs.org/docs/api-reference/next.config.js/introduction and https://github.com/vercel/next.js/blob/canary/packages/next/shared/lib/constants.ts#L1-L5 for
  // more details on NEXT_PHASE
  if (process.env.NODE_ENV === 'production' && process.env.NEXT_PHASE !== 'phase-production-build') {
    Bugsnag.start({
      apiKey: `${process.env.BUGSNAG_API_KEY}`,
      appVersion: process.env.APP_VERSION,
      releaseStage: process.env.RELEASE_STAG,
      plugins: [],
      onError: (event) => {
        const userUuid = store.getState().auth?.userUuid;
        if (userUuid) event.setUser(userUuid);
      },
    });
  }
}
